module.exports = __webpack_public_path__ + "assets/img/logo_default_w.d7bef597.svg";